import React, {useEffect, useState } from "react";
import style from "./index.module.scss";
import { getDomTop } from "@/common/utils";

function Join(props) {

  const [joinTextActive, setJoinTextActive] = useState(false);
  const [joinText2Active, setJoinText2Active] = useState(false);
  const [joinBtnActive, setJoinBtnActive] = useState(false);
  const [boxUpHide, setBoxUpHide] = useState(false);

  const text1Ref = React.createRef();
  const btnRef = React.createRef();
  const text2Ref = React.createRef();
  const boxRef = React.createRef();

  const checkText = (info) => {
    const activeTop = info.clientHeight / 4;
    const text1Top = getDomTop(text1Ref.current);
    setJoinTextActive(info.scrollTop > activeTop && text1Top < info.pageBottom);
  };

  const checkBtn = (info) => {
    const activeTop = info.clientHeight / 2;
    const btnTop = getDomTop(btnRef.current);
    setJoinBtnActive(info.scrollTop > activeTop && btnTop < info.pageBottom);
  };

  const checkText2 = (info) => {
    const activeTop = info.clientHeight / 2 + 120;
    const text2Top = getDomTop(text2Ref.current);
    setJoinText2Active(info.scrollTop > activeTop && text2Top < info.pageBottom);
  };

  const checkBoxHide = (info) => {
    const activeTop = info.clientHeight;
    const boxTop = getDomTop(boxRef.current) + boxRef.current.clientHeight / 2;
    const state = info.scrollTop > activeTop && boxTop < info.pageTop;
    setBoxUpHide(state);
    props.endFun(state);
  };

  const join = () => {
    window.gtag("event", "pc_home_join_top");
    props.join();
  };

  useEffect(() => {
    const info = props.pageInfo;
    checkText(info);
    checkBtn(info);
    checkText2(info);
    checkBoxHide(info);
  }, [props.pageInfo]);

  return (
    <section>
      <div className={`${style.join_box}`}
        style={{transform: `translateY(${boxUpHide ? -20 : 0}vh)`, opacity: `${boxUpHide ? 0.4 : 1}`}}
        ref={boxRef}>
        <p style={{transform: `translateY(${joinTextActive ? 0 : 20}vh)`, opacity: `${joinTextActive ? 1 : 0}`}}
          ref={text1Ref} dangerouslySetInnerHTML={{__html: props.langState.homeData.helpText1}}></p>
        <div className={`${style.join_btn}`}
          style={{transform: `translateY(${joinBtnActive ? 0 : 20}vh)`, opacity: `${joinBtnActive ? 1 : 0}`}}
          ref={btnRef}>
          <div className={`${style.join_pet}`}></div>
          <div className={style.join_enter} onClick={join}>
            <span>{ props.langState.homeData.joinBtn }</span>
          </div>
          <div className={`${style.join_pet_hand}`}>
            <div className={`${style.hand} ${joinBtnActive ? "hand_router" : ""}`}></div>
          </div>
        </div>
        <p className={`${style.join_txt}`}
          style={{transform: `translateY(${joinText2Active ? 0 : 20}vh)`, opacity: `${joinText2Active ? 1 : 0}`}}
          ref={text2Ref}>
          { props.langState.homeData.helpText2 }
        </p>
      </div>
    </section>
  );
}

export default Join;
